import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import styles from "../../styles/components/buyerAccounting.module.scss";
// import Image from 'next/image'
import assest from "../../json/assest";
import ModalWrapperBonus from "../../ui/Modal/ModalWrapper/ModalWrapperBonus";
import BonusModal from "../BonusModal/BonusModal";
// import ModalWrapperBonus from '../../ui/ModalWrapper/ModalWrapperBonus'
// import BonusModal from '../BonusModal/BonusModal'
// import PerfectScrollbar from "react-perfect-scrollbar"
// import "react-perfect-scrollbar/dist/css/styles.css"
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PaymentRequestModal from "../BonusModal/PaymentRequestModal";
import useFetch from "../../hooks/api/useFetch";
import useNotiStack from "../../hooks/useNotistack";
import axiosInstance from "../../api/axiosInstance";
import ApiLoader from "../Loaders/ApiLoader";
import {
  concatDownloadPath,
  concatFileDownloadPath,
  concatHostAndImagePath,
  openInNewTab,
} from "../../lib/functions/utils.lib";

const validationSchema = yup.object().shape({
  amount: yup
    .number()
    .typeError("Amount is required")
    .required("Amount is required")
    .positive("Amount must be a positive number"),
  paypal_email: yup
    .string()
    .required("Paypal Address is required")
    .email("Please insert valid paypal id"),

  notes: yup.string().trim(),
});

const BuyerAccounting = ({
  contentBuyerSubmissions,
  user_id,
  contentBuyerSubmissionsRefetch,
}) => {
  const [openVideoBonus, setOpenVideoBonus] = React.useState(false);
  const [paymentData, setPaymentData] = React.useState("");
  const [formData, setFormData] = React.useState(null);
  const { toastSuccess, toastError } = useNotiStack();

  const handleClickOpenVideoBonus = () => {
    setOpenVideoBonus(true);
  };
  const handleCloseVideoBonus = () => {
    setOpenVideoBonus(false);
  };

  /***********************************/

  const [openPayment, setOpenPayment] = React.useState(false);
  const handleClickOpenPayment = () => {
    setOpenPayment(true);
  };
  const handleClosePayment = () => {
    setOpenPayment(false);
  };

  const {
    data: paymentRequestData,
    refetch,
    isLoading,
  } = useFetch(
    ["paymentRequest", user_id],
    `/admin/get-payemt-request?user_id=${user_id ? user_id : "0"}`
  );

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    setFormData(data);
    handleClickOpenVideoBonus();
  };

  const handlePopupClose = async (confirmed) => {
    if (confirmed) {
      const data = {
        user_id,
        paypal_email: formData?.paypal_email,
        request_amount: formData?.amount,
        note: formData?.note,
      };
      await axiosInstance
        .post("admin/create-payemt-request", data)
        .then((res) => {
          if (res?.status === 200) {
            toastSuccess(res?.data?.message);
            refetch();
            contentBuyerSubmissionsRefetch();
            reset();
          }
        })
        .catch((err) => {
          if (err?.data?.message) {
            toastError(err?.data?.message);
          }
        });
    } else {
      reset();
    }
    handleCloseVideoBonus();
  };
  function formatMonthYear(dateString) {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString("en-US", options);
  }

  const [fileStates, setFileStates] = React.useState({});

  const handleFileChange = (month, index, file) => {
    setFileStates((prevFileStates) => ({
      ...prevFileStates,
      [month]: {
        ...prevFileStates[month],
        [index]: file,
      },
    }));
  };

  const handleUpload = async (month, index, itemId) => {
    const file = fileStates[month][index];

    const formData = new FormData();
    formData.append("admin_recipt", file);
    formData.append("id", itemId);

    await axiosInstance
      .post("admin/update-payment-request", formData)
      .then((res) => {
        if (res?.status === 200) {
          toastSuccess(res?.data?.message);
          refetch();
        }
      })
      .catch((err) => {
        if (err?.data?.message) {
          toastError(err?.data?.message);
        }
      });
  };

  const handleAttachClick = (month, index) => {
    const fileInput = document.getElementById(`fileInput-${month}-${index}`);
    fileInput.click();
  };

  const deleteFileHandle = async (itemId, month, index) => {
    const formData = new FormData();
    formData.append("admin_recipt_delete", true);
    formData.append("id", itemId);

    await axiosInstance
      .post("admin/update-payment-request", formData)
      .then((res) => {
        if (res?.status === 200) {
          toastSuccess(res?.data?.message);
          refetch();
          setFileStates((prevFileStates) => ({
            ...prevFileStates,
            [month]: {
              ...prevFileStates[month],
              [index]: null,
            },
          }));
        }
      })
      .catch((err) => {
        if (err?.data?.message) {
          toastError(err?.data?.message);
        }
      });
  };

  return (
    <Box className={styles.buyerAccountingWrapper}>
      {/* <PerfectScrollbar> */}
      <ApiLoader loading={isLoading} />

      <Stack direction={"row"} className={styles.BuyerAccountRow}>
        <Box
          className={`${styles.buyerAccountItem} ${styles.buyerAccountItemOne}`}
        >
          <Box className={`${styles.buyerlistAccount} commonBuyerAccountBox`}>
            <Box className={styles.paymentHistoryWrapper}>
              <h4>Payments History</h4>
              {paymentRequestData?.data?.data &&
              Object.keys(paymentRequestData.data.data).length > 0 ? (
                <Box className={styles.paymentTable}>
                  <TableContainer component={Paper}>
                    <Table aria-label="spanning table">
                      <TableHead>
                        <TableRow>
                          <TableCell className={styles.thmonth}>
                            Month
                          </TableCell>
                          <TableCell className={styles.thamount}>
                            Amount Requested
                          </TableCell>
                          <TableCell className={styles.thpaypal}>
                            PayPal
                          </TableCell>
                          <TableCell className={styles.thpaid}>
                            Amount Paid
                          </TableCell>
                          <TableCell className={styles.threcieved}>
                            Amount Received
                          </TableCell>
                          <TableCell className={styles.threciept} align="right">
                            Payment Receipt
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {Object.entries(paymentRequestData.data.data).map(
                          ([month, items]) => (
                            <React.Fragment key={month}>
                              <TableRow>
                                <TableCell>
                                  <Box className={styles.tableHeader}>
                                    {formatMonthYear(month)}
                                  </Box>
                                </TableCell>
                                <TableCell colSpan={4}></TableCell>
                              </TableRow>
                              {items.map((item, index) => (
                                <TableRow key={item.id}>
                                  <TableCell></TableCell>
                                  <TableCell>
                                    <Box className={styles.dollarDate}>
                                      <h4>${item.request_amount}</h4>
                                      <p>
                                        {new Date(
                                          item.created_at
                                        ).toLocaleDateString("en-US", {
                                          weekday: "long",
                                          month: "long",
                                          day: "numeric",
                                          year: "numeric",
                                        })}
                                      </p>
                                    </Box>
                                  </TableCell>
                                  <TableCell>{item.paypal_email}</TableCell>
                                  <TableCell>
                                    <Box className={styles.dollarDate}>
                                      <h4> ${item.paid_amount || 0}</h4>
                                      <p>
                                        {new Date(
                                          item.created_at
                                        ).toLocaleDateString("en-US", {
                                          weekday: "long",
                                          month: "long",
                                          day: "numeric",
                                          year: "numeric",
                                        })}
                                      </p>
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    ${item.recived_amount || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.admin_recipt ? (
                                      <Box className={styles.receiptBox}>
                                        <p>
                                          {item?.admin_recipt.slice(0, 20)}...
                                        </p>
                                        <List className={styles.paymentIcon}>
                                          <ListItem>
                                            <Button
                                              onClick={() =>
                                                openInNewTab(
                                                  concatHostAndImagePath(
                                                    item.admin_recipt
                                                  )
                                                )
                                              }
                                            >
                                              <img
                                                src={assest.eyeBlueIcon}
                                                width={11}
                                                height={9}
                                                alt=""
                                              />
                                            </Button>
                                          </ListItem>
                                          <ListItem>
                                            <Button
                                              onClick={() =>
                                                deleteFileHandle(
                                                  item?.id,
                                                  month,
                                                  index
                                                )
                                              }
                                            >
                                              <img
                                                src={assest.deleteRedIcon}
                                                width={11}
                                                height={12}
                                                alt=""
                                              />
                                            </Button>
                                          </ListItem>
                                        </List>
                                      </Box>
                                    ) : (
                                      <Box>
                                        {fileStates[month] &&
                                        fileStates[month][index] ? (
                                          <Button
                                            onClick={() =>
                                              handleUpload(
                                                month,
                                                index,
                                                item?.id
                                              )
                                            }
                                          >
                                            Upload Receipt
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              handleAttachClick(month, index)
                                            }
                                          >
                                            Attach Receipt
                                          </Button>
                                        )}
                                        <input
                                          type="file"
                                          id={`fileInput-${month}-${index}`}
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleFileChange(
                                              month,
                                              index,
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                      </Box>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </React.Fragment>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <Box className={styles.paymentHistory}>
                  <Box>
                    <img
                      src={assest.paymentHistoryImg}
                      width={90}
                      height={90}
                      alt=""
                    />
                    <p>No payments have been processed yet.</p>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          className={`${styles.buyerAccountItem} ${styles.buyerAccountItemTwo}`}
        >
          <Stack direction={"column"}>
            <Box className={styles.BuyerAccountBox}>
              <Box
                className={`${styles.paymentBreakdown} commonBuyerAccountBox`}
              >
                <Box>
                  <h4>Up-To-Date Payments Breakdown</h4>

                  <List>
                    <ListItem>
                      <p>Total amount of purchases</p>
                      <p
                        className={`${styles.paid} ${styles.received} ${styles.owed}`}
                      >
                        <strong>
                          {contentBuyerSubmissions?.data?.data?.accounting
                            ?.total_purchase
                            ? `$ ${contentBuyerSubmissions?.data?.data?.accounting?.total_purchase}`
                            : "-"}
                        </strong>
                      </p>
                    </ListItem>
                    <ListItem>
                      <p>Total amount requested</p>
                      <p
                        className={`${styles.paid} ${styles.received} ${styles.owed}`}
                      >
                        <strong>
                          {contentBuyerSubmissions?.data?.data?.accounting
                            ?.request_amount
                            ? `$ ${contentBuyerSubmissions?.data?.data?.accounting?.request_amount}`
                            : "-"}
                        </strong>
                      </p>
                    </ListItem>
                    <ListItem>
                      <p>Total amount paid</p>
                      <p
                        className={`${styles.paid} ${styles.received} ${styles.owed}`}
                      >
                        <strong>
                          {contentBuyerSubmissions?.data?.data?.accounting
                            ?.paid_amount
                            ? `$ ${contentBuyerSubmissions?.data?.data?.accounting?.paid_amount}`
                            : "-"}
                        </strong>
                      </p>
                    </ListItem>
                    <ListItem>
                      <p>Total amount received</p>
                      <p
                        className={`${styles.paid} ${styles.received} ${styles.owed}`}
                      >
                        <strong>
                          {contentBuyerSubmissions?.data?.data?.accounting
                            ?.recived_amount
                            ? `$ ${contentBuyerSubmissions?.data?.data?.accounting?.paid_amount}}`
                            : "-"}
                        </strong>
                      </p>
                    </ListItem>
                    <ListItem>
                      <p>Total amount owed</p>
                      <p
                        className={`${styles.paid} ${styles.received} ${styles.owed}`}
                      >
                        <strong>
                          {contentBuyerSubmissions?.data?.data?.accounting
                            ?.outstading_balance
                            ? `$ ${contentBuyerSubmissions?.data?.data?.accounting?.outstading_balance}}`
                            : "-"}
                        </strong>
                      </p>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Box>

            <Box className={styles.BuyerAccountBox}>
              <Box
                className={` ${styles.paymentConfirm} commonBuyerAccountBox`}
              >
                <Box className={styles.paymentConfirm}>
                  <h4>Payment Confirmation</h4>
                  {paymentRequestData?.data?.active ? (
                    <Box className={styles.paymentRequestConfirm}>
                      <p>
                        The payment requested on{" "}
                        <strong>
                          {" "}
                          {new Date(
                            paymentRequestData?.data?.active?.created_at
                          ).toLocaleDateString("en-US", {
                            weekday: "long",
                            month: "short",
                            day: "numeric",
                          })}
                          ,
                        </strong>{" "}
                        {paymentRequestData?.data?.active?.accountant_recipt
                          ? "has now been confirmed by the team."
                          : " is pending"}
                      </p>
                      <Button
                        onClick={() =>
                          openInNewTab(
                            concatFileDownloadPath(
                              paymentRequestData?.data?.active
                                ?.accountant_recipt
                            )
                          )
                        }
                        disabled={
                          !paymentRequestData?.data?.active?.accountant_recipt
                        }
                      >
                        Download Receipt
                      </Button>
                    </Box>
                  ) : (
                    <Box className={styles.paymentNoConfirm}>
                      <p>No payment has requested yet.</p>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Stack>
        </Box>

        <Box
          className={`${styles.buyerAccountItem} ${styles.buyerAccountItemThree}`}
        >
          <Box className={` ${styles.paymentRequest} commonBuyerAccountBox`}>
            <Box className={styles.bonusBox}>
              <h4>Payment Request</h4>

              <Box className={styles.bonusBoxInput}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Box className={styles.inputField}>
                    <label>Enter the amount</label>
                    <Controller
                      name="amount"
                      control={control}
                      defaultValue=""
                      render={({ field }) => <input type="number" {...field} />}
                    />
                    {errors.amount && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "15px",
                        }}
                      >
                        {errors.amount.message}
                      </span>
                    )}
                  </Box>

                  <Box className={styles.inputField}>
                    <label>PayPal Address</label>
                    <Controller
                      name="paypal_email"
                      control={control}
                      defaultValue=""
                      render={({ field }) => <input type="text" {...field} />}
                    />
                    {errors.paypal_email && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "15px",
                        }}
                      >
                        {errors.paypal_email.message}
                      </span>
                    )}
                  </Box>

                  <Box className={`${styles.inputField} ${styles.notes}`}>
                    <label>Notes</label>
                    <Controller
                      name="notes"
                      control={control}
                      defaultValue=""
                      render={({ field }) => <textarea {...field} />}
                    />
                    {errors.notes && <p>{errors.notes.message}</p>}
                  </Box>

                  <Button type="submit">
                    <span>Confirm </span> request
                  </Button>
                </form>
              </Box>
            </Box>
          </Box>
        </Box>
      </Stack>
      {/* </PerfectScrollbar> */}

      <ModalWrapperBonus
        open={openVideoBonus}
        onClose={handleCloseVideoBonus}
        handleClose={handleCloseVideoBonus}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <PaymentRequestModal
          paymentData={formData}
          onClose={handlePopupClose}
        />
      </ModalWrapperBonus>

      <ModalWrapperBonus
        open={openPayment}
        onClose={handleClosePayment}
        handleClose={handleClosePayment}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <BonusModal />
      </ModalWrapperBonus>
    </Box>
  );
};

export default BuyerAccounting;
